import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { useTranslation } from 'react-i18next';
import { Link, useNavigate, } from "react-router-dom";
import { useMediaQuery } from "@mui/material";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [isMobile, setIsMobile] = useState(false);
  const { t } = useTranslation();
  const isIpad = useMediaQuery("(max-width:1200px)");

  const userId = Cookies.get("id");

  // Check if screen width is mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // Initial check
    checkMobile();

    // Add event listener for window resize
    window.addEventListener("resize", checkMobile);

    // Clean up
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const styles = {
    footer: {
      width: "100%",
      backgroundColor: "#fafafa",
      padding: isMobile ? "10px 0" : "20px 0",
      marginTop: "auto",
    },
    logo: {
      fontSize: isMobile ? "32px" : "40px",
      fontWeight: "bold",
      color: "#000",
      textAlign: "center",
      margin: "32px 0 0 0",
    },
    divider: {
      width: "100%",
      height: "1px",
      backgroundColor: "#eaeaea",
      margin: "24px 0 0 0",
    },
    menuRow: {
      display: "flex",
      flexDirection: isIpad ? "column" : "row",
      alignItems: isIpad ? "center" : "flex-start",
      justifyContent: isIpad ? "center" : "center",
      width: "100%",
      maxWidth: "1400px",
      margin: isIpad ? "20px auto 0 auto" : "32px auto 0 auto",
      position: "relative",
      gap: isIpad ? "16px" : "0",
    },
    menuItems: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      flex: 1,
      gap: isIpad ? "25px" : "48px",
      fontSize: isIpad ? "15px" : "17px",
      fontWeight: 400,
      color: "#111",
      flexWrap: isIpad ? "wrap" : "nowrap",
      textAlign: "center",
      width: isIpad ? "85%": "auto",
    },
    menuItem: {
      color: "#111",
      textDecoration: "none",
      padding: 0,
      fontSize: isMobile ? "15px" : "17px",
      fontWeight: 400,
      whiteSpace: "nowrap",
      transition: "color 0.2s",
    },
    copyright: {
      margin: "32px 0 0 0",
      color: "#707070",
      fontSize: "14px",
      lineHeight: "1.4",
      textAlign: "center",
      width: "100%",
    },
    socialIcons: {
      display: "flex",
      gap: "24px",
      alignItems: "center",
      justifyContent: isIpad ? "center" : "flex-end",
      position: isIpad ? "static" : "absolute",
      right: isIpad ? "auto" : 0,
      top: isIpad ? "auto" : 0,
      height: isIpad ? "auto" : "100%",
      margin: isIpad ? "24px 0 0 0" : 0,
    },
    socialIcon: {
      width: "24px",
      height: "24px",
      opacity: 0.85,
    },
  };

  return (
    <footer style={styles.footer}>
      <div style={styles.logo}>PTag</div>
      <div style={styles.divider}></div>
      <div style={styles.menuRow}>
        <div style={styles.menuItems}>
          <Link to="/landing" style={styles.menuItem}>
            {t('checkPetTags2')}
          </Link>
          <Link to="/ptag" style={styles.menuItem}>
            PTag
          </Link>
          <Link to="/ptag-air" style={styles.menuItem}>
            PTag Air
          </Link>
          <Link to="/login" style={styles.menuItem}>
            {t('loginFooter')}
          </Link>
          {userId && (
            <Link to="/pet-management" style={styles.menuItem}>
              {t('PetManagementFooter')}
            </Link>
          )}
          <Link to="/aboutus" style={styles.menuItem}>
            {t('AboutUs')}
          </Link>
          <Link to="/privacy" style={styles.menuItem}>
            {t('PrivacyPolicyFooter')}
          </Link>
        </div>
        {/* Social icons right-aligned on desktop, centered on mobile */}
        <div style={styles.socialIcons}>
          <a href="https://instagram.com">
            <img
              src="/icons/ins.png"
              alt="Instagram"
              style={styles.socialIcon}
            />
          </a>
          <a href="https://www.facebook.com/petboysclub">
            <img
              src="/icons/facebook.png"
              alt="Facebook"
              style={styles.socialIcon}
            />
          </a>
          <a href="mailto:info@ptag.com">
            <img src="/icons/email.png" alt="Email" style={styles.socialIcon} />
          </a>
        </div>
      </div>
      <div style={styles.copyright}>
        <div>Copyright© {currentYear} MLHWKT Ltd.</div>
        <div className="mb-12">{t('AllRightReserved')}</div>
      </div>
    </footer>
  );
};

export default Footer;
